"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const PriceMetaTypes_1 = require("../Enum/PriceMetaTypes");
class ValuationData {
    getPriceEvaluations() {
        return this.priceEvaluations;
    }
    setPriceEvaluations(value) {
        this.priceEvaluations = value;
        return this;
    }
    getCreatedAt() {
        return this.createdAt;
    }
    setCreatedAt(value) {
        this.createdAt = value;
        return this;
    }
    getExpiresAt() {
        return this.expiresAt;
    }
    setExpiresAt(value) {
        this.expiresAt = value;
        return this;
    }
    getUpdatedAt() {
        return this.updatedAt;
    }
    setUpdatedAt(value) {
        this.updatedAt = value;
        return this;
    }
    getOutstandingFinanceValue() {
        return this.outstandingFinanceValue;
    }
    setOutstandingFinanceValue(value) {
        this.outstandingFinanceValue = value;
        return this;
    }
    getTotalEquity() {
        return this.totalEquity;
    }
    setTotalEquity(value) {
        this.totalEquity = value;
        return this;
    }
    hasPriceRanges() {
        return !!this.getPriceEvaluations().find((priceEvaluation) => priceEvaluation.getEvaluationType().indexOf(`:${PriceMetaTypes_1.PriceMetaTypes.MIN}`) !== -1);
    }
}
exports.default = ValuationData;
